import React, { useState } from 'react';
import { FaEnvelope, FaCheck } from 'react-icons/fa';
import { envoyerMessage } from '../../services/contactService';

const departments = [
  { name: 'Direction Générale', email: 'contact@tse-consultant-int.cloud' },
  { name: 'Ressources Humaines', email: 'rh@tse-consultant-int.cloud' },
  { name: 'Finance & Administration', email: 'dep.finance@tse-consultant-int.cloud' },
  { name: 'Informatique (IT)', email: 'it@tse-consultant-int.cloud' },
  { name: 'Produits', email: 'produits@tse-consultant-int.cloud' },
  { name: 'Logistique & Stocks', email: 'dep.logistique@tse-consultant-int.cloud' },
  { name: 'Communication & Marketing', email: 'dep.marketing-communication@tse-consultant-int.cloud' },
  { name: 'Département Commercial', email: 'dep.commercial@tse-consultant-int.cloud' },
  { name: 'Support & Maintenance', email: 'dep.support-maintenance@tse-consultant-int.cloud' },
];

const Contact = () => {
  const [copied, setCopied] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    sujet: '',
    message: '',
  });

  const handleCopy = (email) => {
    navigator.clipboard.writeText(email);
    setCopied(email);
    setTimeout(() => setCopied(null), 2000);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await envoyerMessage({
        nom: formData.nom,
        email: formData.email,
        Sujet: formData.sujet, // 👈 correspondance avec backend
        message: formData.message,
      });

      alert('✅ Votre message a été envoyé avec succès !');
      setFormData({ nom: '', email: '', sujet: '', message: '' });
    } catch (error) {
      console.error(error);
      alert('❌ Une erreur est survenue lors de l’envoi du message.');
    } finally {
      setLoading(false);
    }
  };


  return (
    <section style={styles.section}>
      <h2 style={styles.heading}>📧 Nos adresses e-mail professionnelles</h2>
      <p style={styles.text}>
        Vous pouvez contacter directement le service souhaité :
      </p>

      <div style={styles.grid}>
        {departments.map((dept, index) => (
          <div key={index} style={styles.card}>
            <div style={styles.cardHeader}>
              <FaEnvelope style={styles.icon} />
              <h3 style={styles.department}>{dept.name}</h3>
            </div>
            <div style={styles.emailRow}>
              <span style={styles.email}>{dept.email}</span>
              <button
                onClick={() => handleCopy(dept.email)}
                style={styles.copyButton}
                title="Copier"
              >
                {copied === dept.email ? <FaCheck /> : '📋'}
                {copied === dept.email && (
                  <span style={styles.copiedText}> Copié !</span>
                )}
              </button>
            </div>
          </div>
        ))}
      </div>

      <div style={styles.formContainer}>
        <h2 style={{ ...styles.heading, marginTop: '3rem' }}>📨 Contactez-nous</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            name="nom"
            placeholder="Votre nom"
            value={formData.nom}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="email"
            name="email"
            placeholder="Votre adresse e-mail"
            value={formData.email}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="text"
            name="sujet"
            placeholder="Sujet"
            value={formData.sujet}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <textarea
            name="message"
            placeholder="Votre message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="5"
            style={styles.textarea}
          />
          <button type="submit" style={styles.submitButton} disabled={loading}>
            {loading ? 'Envoi en cours...' : 'Envoyer'}
          </button>
        </form>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '2rem',
    backgroundColor: '#f8fafc',
    borderRadius: '10px',
    maxWidth: '1100px',
    margin: '2rem auto',
    fontFamily: 'sans-serif',
    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.05)',
  },
  heading: {
    fontSize: '2rem',
    textAlign: 'center',
    marginBottom: '1rem',
    color: '#2c3e50',
  },
  text: {
    textAlign: 'center',
    marginBottom: '2rem',
    color: '#555',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '1.5rem',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.08)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    cursor: 'pointer',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.75rem',
  },
  icon: {
    marginRight: '0.6rem',
    fontSize: '1.2rem',
    color: '#4a90e2',
  },
  department: {
    fontSize: '1.2rem',
    margin: 0,
    color: '#2c3e50',
  },
  emailRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    wordBreak: 'break-word',
  },
  email: {
    backgroundColor: '#eef3fa',
    padding: '0.4rem 0.6rem',
    borderRadius: '6px',
    fontFamily: 'monospace',
    fontSize: '0.9rem',
    color: '#2c3e50',
  },
  copyButton: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#4a90e2',
    cursor: 'pointer',
    fontSize: '1rem',
  },
  copiedText: {
    marginLeft: '0.3rem',
    fontSize: '0.85rem',
    color: '#28a745',
  },
  formContainer: {
    marginTop: '3rem',
    padding: '2rem',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 6px 16px rgba(0,0,0,0.06)',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  input: {
    padding: '0.75rem',
    borderRadius: '8px',
    border: '1px solid #ccc',
    fontSize: '1rem',
  },
  textarea: {
    padding: '0.75rem',
    borderRadius: '8px',
    border: '1px solid #ccc',
    fontSize: '1rem',
  },
  submitButton: {
    padding: '0.8rem',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#4a90e2',
    color: '#fff',
    fontSize: '1rem',
    cursor: 'pointer',
    //opacity: loading ? 0.6 : 1,
    //pointerEvents: loading ? 'none' : 'auto',
  },
};

export default Contact;
